export default {
  tr: "Türkçe",
  en: "English",
  s360: "360 Sosyal",
  sosyal360: "360Sosyal",
  gigcep: "GigCep",
  social: "Sosyal",
  login: "Giriş Yap",
  register: "Kayıt Ol",
  sign_in: "Kayıt Ol",
  close: "Kapat",
  close_all: "Tümünü Kapat",
  closed: "Kapalı",
  open: "Açık",
  open_all: "Tümünü Aç",
  opened: "Açık",
  changed_price_count: "Değişen fiyat adedi: {0}",
  change_rates: "Oranları Değiştir",
  constant_name_api_price_rate: "API Fiyat Oranı",
  constant_name_user_price_rate: "Kullanıcı Fiyat Oranı",
  constant_name_api_user_price_rate: "API Kullanıcı Fiyat Oranı",
  constant_name_perfect_earning_rate: "Perfect Kazanç Oranı",
  constant_name_gender_price: "Cinsiyet Fiyatı",
  constant_name_booster_price: "Booster Fiyatı",
  constant_name_approve_price: "Onay Fiyatı",
  constant_name_api_approve_price: "API Onay Fiyatı",
  send: "Gönder",
  logout: "Oturumu Kapat",
  id: "ID",
  code: "Kodu",
  email: "E-posta",
  name: "Adı",
  instance_id: "Instance ID",
  token: "Token",
  whatsapp_instances: "WhatsApp Instance'ları",
  whatsapp_instance_create: "WhatsApp Instance Oluştur",
  whatsapp_instance_update: "WhatsApp Instance Güncelle",
  whatsapp_messages: "WhatsApp Mesajlar",
  whatsapp_message_create: "Otomatik WhatsApp Mesajı Oluştur",
  whatsapp_message_update: "Otomatik WhatsApp Mesajını Güncelle",
  whatsapp_instance: "WhatsApp Instance",
  whatsapp_group: "WhatsApp Grubu",
  interval_minutes: "Gönderim Aralığı (Dakika)",
  last_sent_at: "Son Gönderim",
  last_error: "Son Hata",
  loading: "Yükleniyor...",
  surname: "Soyadı",
  national_id: "Kimlik Numarası",
  password: "Şifre",
  password_confirmation: "Şifre onayı",
  birthdate: "Doğum günü",
  phone: "Telefon",
  gender: "Cinsiyet",
  error: "Hata",
  success: "Başarılı",
  welcome_back: "Hoşgeldiniz",
  enter_your_account_credentials:
    "Oturum açmak için hesap bilgilerinizi giriniz",
  have_an_account: "Bir Hesabım Var",
  dont_have_an_account: "Hesabım Yok",
  dont_have_an_account1: "Hesabınız yok mu?",
  login_to_account: "Hesaba Giriş Yapın",
  login_to_another_account: "Başka bir hesapla giriş yap",
  start_by_creating_account: "Hesabınızı oluşturarak başlayalım",
  create_account: "Hesap oluştur",
  create_account1: "Hesap oluşturun",
  login_here: "Giriş Yapın",
  all_ready_account: "Zaten hesabınız var mı?",
  all_rights_reserved: "Tüm hakkları saklıdır",
  forgot_your_password: "Parolamı unuttum",
  remember_this_account: "Hesabı hatırla",
  remember_this_member: "Beni Hatırla",
  no_matching_results: "Eşleşen sonuç yok",
  no_matching_results_content:
    "Arama terimlerinizle eşleşen bir sonuç bulamadık. Diğer arama terimlerini deneyin.",
  table_you_have_selected: "Toplam {1} öğeden {0} öğeyi seçtiniz",
  are_you_sure: "İşlemi yapmak istediğinize emin misiniz?",
  are_you_sure_delete: "Silmek istediğinize emin misiniz?",
  are_you_sure_clone: "Klonlamak istediğinize emin misiniz?",
  are_you_sure_bulk_approve:
    "Bütün kanıtları onaylamak istediğinize emin misiniz?",
  are_you_sure_bulk_approve_reward:
    "Bütün ödül taleplerini onaylamak istediğinize emin misiniz?",
  are_you_sure_take_reward: "Ödülü almak istediğinize emin misiniz?",
  are_you_sure_approve: "Onaylamak istediğinize emin misiniz?",
  are_you_sure_banned: "Yasaklamak istediğinize emin misiniz?",
  are_you_sure_decline: "Reddetmek istediğinize emin misiniz?",
  are_you_sure_giveup: "Vazgeçmek istediğinize emin misiniz?",
  are_you_sure_buy: "Satın almak istediğinize emin misiniz?",
  are_you_sure_delete_name:
    "{0} kullanıcısını silmek istediğinize emin misiniz?",
  are_you_sure_delete_social_account:
    "{0} sosyal medya hesabını silmek istediğinize emin misiniz?",
  are_you_sure_banned_social_account:
    "{0} hesabını yasaklamak istediğinize emin misiniz?",
  are_you_sure_banned_user:
    "{0} kullanıcısını banlamak istediğinize emin misiniz?",
  are_you_sure_mission_give_up: "Gigi bırakmak istediğimize emin misiniz?",
  are_you_sure_mission_end: "Gigi sonlandırmak istediğimize emin misiniz?",
  are_you_sure_send_telegram_notification:
    "{count} adet görevi bildirim olarak göndermek istediğinize emin misiniz?",
  no_gig_was_found_to_send_notification_to:
    "Bildirim gönderilecek bir gig bulunamadı.",
  filter: "Ara",
  edit: "Düzenle",
  back: "Geri",
  save: "Kaydet",
  delete: "Sil",
  cancel: "İptal",
  create: "Oluştur",
  new: "Yeni",
  old: "Eski",
  old_new_diff: "Eski/Yeni Fark",
  yes: "Evet",
  no: "Hayır",
  key: "Alan Adı",
  type: "Tip",
  value: "Değer",
  action: "İşlem Yap",
  string: "Metin",
  int: "Sayı",
  bool: "Aktif/Pasif",
  filters: "Filtreler",
  filter_clear: "Filtreleri Temizle",
  filter_apply: "Filtreleri Uygula",
  announcement: "Duyurular",
  announcement_create: "Duyuru Oluştur",
  announcement_update: "Duyuru Güncelle",
  subject: "Konu",
  short_explanation: "Kısa Açıklama",
  explanation: "Açıklama",
  address: "Adres",
  roles: "Roller",
  roles_create: "Rol Oluştur",
  roles_update: "Rol Güncelle",
  role: "Rol",
  start_date: "Başlangıç Tarihi",
  end_date: "Bitiş Tarihi",
  register_date: "Kayıt Tarihi",
  one_week: "1 Hafta",
  one_month: "1 Ay",
  one_year: "1 Yıl",
  dates: {
    start: "Başlangıç Tarihi",
    end: "Bitiş Tarihi",
  },
  status: "Durum",
  statuses: "Durumlar",
  admin: "Admin",
  user: "Kullanıcı",
  controller: "Kontrolcü",
  process: "İşlem",
  users: "Kullanıcılar",
  users_create: "Kullanıcı Oluştur",
  users_update: "Kullanıcı Güncelle",
  active: "Aktif",
  passive: "Pasif",
  header: "Başlık",
  url: "Url Adres",
  verification_code: "Sms Doğrulama Kodu",
  mobile_verification_code: "Telefon Doğrulama Kodu",
  email_verification_code: "E-mail Doğrulama Kodu",
  verify: "Doğrula",
  blocked_links: "Engellenen Adresler",
  blocked_links_create: "Engellenen Adres Oluştur",
  blocked_links_update: "Engellenen Adres Güncelle",
  constants: "Sabitler",
  constants_create: "Sabit Oluştur",
  constants_update: "Sabit Güncelle",
  quick_answers: "Hızlı Cevaplar",
  quick_answers_create: "Hızlı Cevap Oluştur",
  quick_answers_update: "Hızlı Cevap Güncelle",
  contracts: "Sözleşmeler",
  contracts_create: "Sözleşme Oluştur",
  contracts_update: "Sözleşme Güncelle",
  name_tr: "Adı Türkçe",
  name_en: "Adı İngilizce",
  login_settings: "Kayıt Ayarları",
  view_content: "İçeriği Görüntüle",
  edit_content: "İçeriği Düzenle",
  parameters: "Parametreler",
  parameters_create: "Parametre Oluştur",
  parameters_update: "Parametre Güncelle",
  parameter_edit: "Parametre Düzenle",
  parameter_items: "Parametre İçerikleri",
  parameter_items_create: "Parametre İçeriği Oluştur",
  parameter_items_update: "Parametre İçeriği Güncelle",
  registration_mernis_verification: "Mernis Kayıt Doğrulama",
  mernis_url: "Mernis Adresi",
  verification_message: "Doğrulama Mesajı",
  two_factor_message: "İki Yönlü Doğrulama",
  registration_mobile_verification: "Mobil Doğrulama",
  data: "Veri",
  please_select: "Seçiniz",
  select: "Seçiniz",
  manage_account: "Hesabı yönet",
  my_account: "Hesabım",
  services: "Servisler",
  services1: "Hizmetler",
  services2: "Hizmetleri",
  services_create: "Servis Oluştur",
  services_update: "Servis Güncelle",
  bulk_service_update: "Toplu Servis Güncelleme",
  service_categories: "Servis Kategorileri",
  service: "Servis",
  service_category: "Servis Kategori",
  servicecategory: "Servis Kategorileri",
  service_category_rules: "Servis Kategori Kuralları",
  service_category_rules_update: "Servis Kategori Kuralı Güncelle",
  servicecategoryrule: "Servis Kategori Kural",
  is_active: "Aktif",
  rank: "Sıra",
  role_privileges: "Rol Yetkileri",
  role_privileges_edit: "Rol Yetkileri Düzenle",
  privilege_edit: "Yetkileri Düzenle",
  approval_required: "Onay Gerekli",
  unique_account: "Benzersiz Hesap",
  regex: "Regex",
  service_id: "Servis",
  service_category_id: "Servis Kategori",
  pages: "Sayfalar",
  content: "İçerik",
  search: "Ara",
  username: "Kullanıcı Adı",
  name_or_lastname: "Name & Lastname",
  per_page_val: "Sayfa başına {0}",
  confirm_your_account: "Hesabınızı doğrulamanız gerekmektedir",
  verify_hi_message:
    "Merhaba, seni aramızda görmekten mutluluk duyuyoruz! Uygulamamızı kullanmaya devam etmek için lütfen hesabınızı doğrulayın",
  settings_welcome_message:
    "Hoşgeldiniz bu sayfadan uygulama ayarlarını değiştirebilirsiniz",
  content_you_were_looking_for_not_found: "Aradığınız içerik bulunamadı",
  view_profile: "Profili Görüntüle",
  edit_profile: "Profil Düzenleme",
  edit1: "Düzenleme",
  general: "Genel",
  settings: "Ayarlar",
  admin_settings: "Admin Ayarları",
  system_settings: "Sistem Ayarları",
  general_info: "Genel Bilgiler",
  edit_your_accounts_general_information:
    "Hesabınızın genel bilgilerini düzenleyin",
  user_information_has_been_updated: "Kullanıcı güncellendi",
  this_form_has_errors:
    "Bu formda {0} hata var, lütfen göndermeden önce bunları kontrol edin",
  fill_out_form_user_creation: "Kullanıcı oluşturmak için formunu doldurun",
  fill_out_form_ticket: "Destek Talebi oluşturmak için formunu doldurun",
  personal_information: "Kişisel Bilgiler",
  social_media: "Sosyal Medya",
  profile_picture: "Profil Fotoğrafı",
  others_will_recognize_you: "Başkaları sizi bu şekilde tanıyacak",
  preview: "Ön izleme",
  remove_image: "Resmi kaldır",
  profile_info: "Profil Bilgisi",
  others_to_know_you_more: "Diğerleri seni daha fazla tanımayı hak ediyor",
  reset: "Sıfırla",
  your_social_media_accounts: "Sosyal medya hesaplarınız",
  your_references: "Referanslarınız",
  your_banned_social_media_accounts: "Yasaklı Sosyal medya hesaplarınız",
  your_payment_accounts: "Ödeme hesaplarınız",
  your_ticket_requests: "Destek talepleriniz",
  your_reward_requests: "Ödül talepleriniz",
  your_missions: "Gigleriniz",
  your_payment_plans: "Ödeme İşlemleriniz",
  delete_user: "Kullanıcıyı Sil",
  profile: "Profil",
  my_profile: "Profilim",
  view_your_profile: "Profilinizi görüntüleyin",
  change_password: "Şifre Değiştir",
  old_password: "Eski Şifre",
  new_password: "Yeni Şifre",
  new_password_again: "Yeni Şifre Tekrar",
  for_an_improved_account_security: "Gelişmiş hesap güvenliği için",
  edit_your_account_prefs_and_settings:
    "Hesap tercihlerinizi ve ayarlarınızı düzenleyin",
  your_settings_has_been_saved: "Ayarlarınız kaydedildi",
  two_factor: "2 Aşamalı Doğrulama",
  two_factor_auth: "2 Faktörlü Kimlik Doğrulaması",
  two_factor_authentication: "İki faktörlü kimlik doğrulama",
  toggle_two_factor_authentication: "2 faktörlü kimlik doğrulamayı değiştir",
  enter_your_code: "Kodu giriniz",
  enter_the_pin_code_just_sent_you:
    "Size az önce gönderdiğimiz pin kodunu girin",
  is_the_demo_pin: "PIN bu şekilde olmalı",
  take_me_to_home: "Ana sayfaya gidelim",
  didnt_receive_the_code: "Kodu almadınız",
  log_in_again: "Tekrar giriş yap",
  edit_your_social_media_info: "Sosyal medya bilgilerini düzenleyin",
  edit_your_referance_info: "Referans bilgilerini düzenleyin",
  edit_your_payment_account_info: "Ödeme hesabı bilgilerini düzenleyin",
  edit_your_ticket_request_info: "Destek talepleri bilgilerini görüntüleyin",
  edit_your_notifications_info: "Bildirim bilgilerini görüntüleyin",
  edit_your_reward_request_info: "Ödül talepleri bilgilerini görüntüleyin",
  edit_your_mission_info: "Gig bilgilerini görüntüleyin",
  edit_your_proof_info: "Kanıt bilgilerini görüntüleyin",
  edit_your_payment_plan_info: "Bakiye işlemleri bilgilerini görüntüleyin",
  no_social_media: "Sosyal medya yok",
  no_referance: "Referans yok",
  no_payment_account: "Ödeme hesabı yok",
  no_ticket_request: "Destek talebi yok",
  no_reward_request: "Ödül talebi yok",
  no_mission: "Gig yok",
  no_proof: "Kanıt yok",
  no_payment_plan: "Ödeme işlemi yok",
  looks_like_you_didnt_social_media:
    "Henüz sosyal medya eklememişsiniz gibi görünüyor. Profilinizi geliştirmek için deneyiminizi paylaşın",
  looks_like_you_didnt_payment_account:
    "Henüz ödeme hesabı eklememişsiniz gibi görünüyor.",
  looks_like_you_didnt_ticket_request:
    "Henüz destek talebi oluşturmamışsınız gibi görünüyor.",
  looks_like_you_didnt_reward_request:
    "Henüz ödül talebi oluşturmamışsınız gibi görünüyor.",
  looks_like_you_didnt_mission: "Henüz gig oluşturmamışsınız gibi görünüyor.",
  looks_like_you_didnt_proof: "Henüz kanıt oluşturmamışsınız gibi görünüyor.",
  looks_like_you_didnt_payment_plan:
    "Henüz ödeme işlemi oluşturmamışsınız gibi görünüyor.",
  add_social_media: "Sosyal Medya Ekle",
  this_allows_tasks_on_that_platform_app:
    "Bu, uygulamada söz konusu platformda gigleri gerçekleştirmenize olanak tanır",
  new_social_media: "Yeni Sosyal Medya",
  new_reference: "Yeni Referans",
  new_payment_account: "Yeni Ödeme Hesabı",
  new_ticket_request: "Yeni Destek Talebi",
  new_reward_request: "Yeni Ödül Talebi",
  new_mission: "Yeni Gig",
  new_payment_plan: "Yeni Ödeme İşlemi",
  add_a_new_social_media_account: "Yeni bir sosyal medya hesabı ekleyin",
  add_a_new_payment_account: "Yeni bir ödeme hesabı ekleyin",
  add_a_new_ticket_request: "Yeni bir destak talebi oluşturun",
  add_a_new_reward_request: "Yeni bir ödül talebi oluşturun",
  add_a_new_mission: "Yeni bir gig oluşturun",
  add_a_payment_plan: "Yeni bir ödeme planı oluşturun",
  social_media_add: "Sosyal Medya Hesabı Ekle",
  finance: "Finans",
  payment_transactions: "Ödeme İşlemleri",
  references: "Referanslar",
  reference_create: "Referans Oluştur",
  reference_update: "Referanslar Güncelle",
  reference_list: "Referansları",
  reference_details: "Referans Detayları",
  account_settings: "Hesap Ayarları",
  account_name: "Hesap Adı",
  is_unique_account: "Benzersiz Hesap",
  is_approval_required: "Onay Gereksin mi?",
  icons: "İkonlar",
  icon: "Icon",
  home: "Anasayfa",
  social_accounts: "Sosyal Hesaplar",
  social_account: "Sosyal Hesap",
  social_account_proofs: "Sosyal Hesap Kanıtları",
  approved: "Onaylandı",
  approved1: "Onaylanan",
  approved2: "Onaylananlar",
  approved3: "Onayla",
  approved4: "Onaylı",
  not_approved: "Onaylı Değil",
  approve: "Onayla",
  pending: "Onay Bekliyor",
  declined: "Reddedildi",
  declined1: "Reddedilen",
  declined2: "Reddedilenler",
  declined3: "Reddet",
  declined_requests: "Reddetme Talepleri",
  declined_request: "Reddetme Talebi",
  terminated: "Sonlandırıldı",
  terminate: "Sonlandır",
  decline: "Reddet",
  waiting: "Bekleniyor",
  waiting_payment: "Ödeme Bekleniyor",
  paid: "Ödendi",
  male: "Erkek",
  female: "Kadın",
  avatar: "Avatar",
  actions: "İşlemler",
  role_edit: "Rol Düzenle",
  role_add: "Rol Ekle",
  role_add_desc: "Kullanıcıya rol atayabilirsiniz",
  edit_role_info: "Role bilgilerini düzenleyin",
  user_role_information: "Kullanıcının Rol Bilgileri",
  user_role_information_desc:
    "Kullanıcıya yeni roller atanabilir ve rollerini kaldırabilirsiniz",
  no_user_role: "Kullanıcı için bir rol tanımlamadınız",
  service_edit: "Servis Düzenle",
  service_create: "Servis Ekle",
  api_name: "Api Adı",
  api_explanation: "Api Açıklama",
  customer_warning: "Müşteri Uyarı Bilgisi",
  customer_info: "Müşteri Bilgisi",
  warning: "Uyarı",
  next_step: "Sonraki Adım",
  previous_step: "Önceki Adım",
  pricing_settings: "Fiyatlandırma Ayarları",
  min_order_count: "Minimum Sipariş Sayısı",
  max_order_count: "Maksimum Sipariş Sayısı",
  api_min_order_count: "Api Minimum Sipariş Sayısı",
  api_max_order_count: "Api Maksimum Sipariş Sayısı",
  min_proof_count: "Minimum Kanıt Sayısı",
  max_proof_count: "Maksimum Kanıt Sayısı",
  mission_time: "Gig süresi",
  url_shorter: "Url Kısaltıcı",
  api_is_active: "Api Durumu",
  automatic_approve: "Otomatik Onay",
  price: "Fiyat",
  total_price: "Toplam Fiyat",
  api_price: "Api Fiyat",
  approve_price: "Onay Fiyatı",
  api_approve_price: "Api Onay Fiyatı",
  user_price: "Kullanıcı Fiyatı",
  api_user_price: "Api Kullanıcı Fiyatı",
  gender_price: "Cinsiyet Fiyatı",
  booster_price: "Yükseltici Fiyatı",
  always_open_price: "Daima Açık Fiyatı",
  service_count: "Servis Sayısı",
  new_password_confirmation: "Yeni Şifre Tekrar",
  send_new_password: "Yeni Şifre Gönder",
  send_new_password_info:
    "Kullanıcının şifresini değiştirip SMS olarak göndermek istediğinize emin misiniz ?",
  total: "Toplam",
  records: "Kayıt",
  banned_social_account: "Yasaklanan Hesaplar",
  banned_social_account_create: "Yasaklanan Hesap Oluştur",
  banned_social_account_update: "Yasaklanan Hesap Oluştur Güncelle",
  social_account_banned: "Sosyal Hesabı Yasakla",
  social_account_delete: "Sosyal Hesabı Sil",
  account: "Hesap",
  page_create: "Sayfa Oluştur",
  page_update: "Sayfa Güncelle",
  packages: "Paketler",
  packages_create: "Paket Oluştur",
  packages_update: "Paket Güncelle",
  package_informations: "Paket Bilgileri",
  balance: "Bakiye",
  current_balance: "Mevcut Bakiye",
  balance_change: "Bakiye Değişim Tutarı",
  balance_change1: "Bakiye Değişimi",
  balance_change_placeholder: "100 veya -100 giriniz",
  current_point: "Mevcut Puan",
  point_change: "Puan Değişim Tutarı",
  point_change_placeholder: "100 veya -100 giriniz",
  old_balance: "Eski Bakiye",
  old_point: "Eski Puan",
  new_balance: "Yeni Bakiye",
  new_point: "Yeni Puan",
  balance_point: "Bakiye / Puan",
  balance_history: "Bakiye Geçmişi",
  daily_bonus_history: "Günlük Bonus Geçmişi",
  point_history: "Puan Geçmişi",
  bonus: "Bonus",
  related_id: "İlişkili ID",
  history: "Geçmişi",
  description: "Açıklama",
  payment_plans: "Ödeme İşlemleri",
  payment_plans_create: "Ödeme Planı Oluştur",
  payment_plans_update: "Ödeme Planı Güncelle",
  my_payment_plans: "Ödeme İşlemlerim",
  amount_paid: "Ödenen Miktar",
  loaded_balance: "Yüklenen Bakiye",
  amount: "Tutar",
  payment_type: "Ödeme Türü",
  card: "Kart",
  package: "Paket",
  balance_to_be_earned: "Kazanılacak Bakiye",
  amount_to_be_paid: "Ödenecek Tutar",
  created_at: "Oluşturulma Tarihi",
  created_at2: "Oluşturulma",
  proof_date: "Kanıt Tarihi",
  updated_at: "Güncelleme Tarihi",
  payment_date: "Ödeme Tarihi",
  payment_date2: "Ödeme",
  balance_top_up: "Bakiye Yükle",
  my_payment_transactions: "Ödeme İşlemlerim",
  package_id: "Paket",
  i_made_the_payment: "Ödemeyi Yaptım",
  payment_awaited: "Ödeme bekleniyor",
  missions: "Gigler",
  my_missions: "Giglerim",
  mission: "Gig",
  missions_create: "Gig Oluştur",
  missions_update: "Gig Güncelle",
  mission_detail: "Gig Detay",
  missions_show: "Gig Görüntüle",
  banned: "Yasakla",
  banned1: "Yasaklı",
  user_with_social_account_banned: "Kullanıcı İçin Yasakla",
  general_ban: "Genel Yasak",
  status_update: "Durum Güncelle",
  update: "Güncelle",
  fill_out_form_task_creation: "Gig oluşturmak için formu doldurun",
  fill_out_form_gig_creation: "Gig oluşturmak için formu doldurun",
  fill_out_form_subscription_creation:
    "Abonelik oluşturmak için formu doldurun",
  fill_out_form_ticket_creation: "Destek talebi oluşturmak için formu doldurun",
  person_count: "Kişi Sayısı",
  total_person_count: "Toplam Kişi Sayısı",
  daily_person_count: "Günlük Kişi Sayısı",
  approve_type: "Onay Tipi",
  boost: "Öne Çıkar",
  user_id: "Kullanıcı",
  show: "Görüntüle",
  fullname: "İsim Soyisim",
  name_surname_email_phone: "İsim & Soyisim & Eposta & Telefon",
  pay: "Ödeme Yap",
  informations: "Bilgiler",
  package_name: "Paket Adı",
  payment: "Ödeme",
  not_found: "Bulunamadı",
  send_message: "Mesaj Gönder",
  points: "Puanlar",
  point: "Puan",
  color: "Renk",
  rate: "Oran",
  upload_points: "Puan Yükle",
  message: "Mesaj",
  upload_evidence: "Kanıt Yükle",
  waiting_proof: "Kanıt Bekleniyor",
  waiting_approve: "Onay Bekleniyor",
  decline_request: "Red Talep Edildi",
  evidence_image: "Kanıt Görseli",
  file: "Dosya",
  file_upload: "Dosya Yükle",
  image: "Görsel",
  image_upload: "Görsel Yükle",
  proof: "Kanıt",
  proof_image: "Kanıt Görseli",
  reason: "Sebep",
  reason_textarea_info: "Reddetme durumunda gereklidir",
  confirm_proof_for_name_account: "{0} hesabının kanıtı için işlem yapın",
  process_in_order: "Sırayla İşlem Yap",
  accounts_awaiting_approval: "Onay Bekleyen Hesaplar",
  send_email: "E-posta Gönder",
  add: "Ekle",
  balance_packages: "Bakiye Paketleri",
  package_with_number: "Paket {0}",
  buy: "Satın Al",
  purchase_the_package_info:
    "Paketi satın almak için {0} TL ödemeniz gerekiyor, hesabınıza yüklenecek bakiye tutarı ise {1} puan.",
  refresh: "Yenile",
  keyy: "Anahtar",
  image_size_large_error: `Resim yüklenemedi, boyutu 1 MB'dan fazla`,
  enter_ban_duration: "Ban Süresini Girin (Gün)",
  enter_integer: "Tam Sayı Giriniz",
  system: "Sistem",
  detail: "Detay",
  step_num: "Adım {0}",
  contiune: "Devam Et",
  stop: "Durdur",
  mission_start: "Gige Başla",
  mission_stop: "Gigi Bırak",
  category: "Kategori",
  personal: "Kişisel",
  all: "Hepsi",
  avaible: "Uygun",
  mission_steps: "Gig Adımları",
  mission_started: "Gig Başlatıldı",
  remaining_time: "Kalan süre",
  people_remaining: "Kalan Kişi",
  remaining_evidence: "Kalan Kanıt",
  list_available_tasks: "Uygun gigleri listele",
  mission_continues: "Devam Ediyor",
  past_missions: "Geçmiş Giglerim",
  proof_pending_approval: "Onay Bekleyen Kanıtlar",
  proof_approved: "Onaylanan Kanıtlar",
  my_proof_pending_approval: "Onay Bekleyen Kanıtlarım",
  missions_pending_approval: "Onay Bekleyen Gigler",
  proofs: "Kanıtlar",
  gig_proofs: "Gig Kanıtları",
  proofs_all: "Tüm Kanıtlar",
  proofs_all_approve: "Tüm Kanıtları Onayla",
  pending_proofs: "Bekleyen Kanıtlar",
  quit_mission: "Gig Bırak",
  mission_create: "Gig Oluştur",
  mission_end: "Gig Sonlandır",
  number_images_you_need_upload: "Yüklemeniz gereken görsel sayısı",
  mission_link: "Gig Linki",
  missions_bearing_proof: "Kanıt Yüklenen Gigler",
  missions_my_bearing_proof: "Kanıt Yüklenen Giglerim",
  mission_name: "Gig Adı",
  proof_count: "Kanıt Sayısı",
  mission_point: "Gig Puanı",
  add_step: "Adım Ekle",
  system_confirm: "Sistem Otomatik Onaylasın",
  personal_confirm: "Kendim Onaylayacağım",
  you_are_missing_price: "{0}'{1} Kaçırıyorsunuz",
  at_least: "En Az",
  most: "En Fazla",
  you_did_not_complete_mission: "Belirtilen Sürede Gigi Tamamlamadınız!",
  second: "Saniye",
  couldnt_find_mission_matching:
    "Arama terimlerinizle eşleşen bir gig bulamadık. Diğer arama terimlerini deneyin.",
  step: "Adım",
  steps_desc: "Aşağıdaki gig adımlarını takip ederek gigi yapabilirsiniz.",
  done: "Tamamlandı",
  mission_rules: "Gig Kuralları",
  banned_users: "Yasaklı Kullanıcılar",
  banned_finish_date: "Yasak Bitiş Tarihi",
  banned_date: "Yasaklanma Tarihi",
  banner_user: "Yasaklayan Kullanıcı",
  banned_time: "Ban Süresi (Gün)",
  user_ban: "Kullanıcı Yasakla",
  cancel_ban: "Yasaklamayı Kaldır",
  proof_rejection_request: "Kanıt Red İstekleri",
  can_description: "Açıklama Girebilir",
  can_daily_person_count: "Günlük Kişi Sayısı Girebilir",
  mission_create_service_step:
    "Kullanıcının gig adımlarını görmek için tıklayın.",
  decline_count: "Red Sayısı",
  mission_status: "Gig Durumu",
  proof_status: "Kanıt Durumu",
  quick_action: "Hızlı İşlem",
  confirm_reject: "Reddetmeyi Onayla",
  no_confirmation: "Onaylama",
  reject_proofs: "Reddedilen Kanıtlar",
  my_rejected_proofs: "Reddedilen Kanıtlarım",
  missions_have_done: "Yaptığım Gigler",
  missions_awaiting_approval: "Onay Bekleyen Kanıtlarım",
  approved_missions: "Onaylanan Kanıtlarım",
  rejected_missions: "Reddedilen Kanıtlarım",
  take_action: "İşlem Yap",
  approve_proof: "Kanıtı Onayla",
  re_upload_proof: "Yeniden Kanıt Yükle",
  give_up_mission: "Gigi Bırak",
  gain: "Kazanç",
  lost: "Kayıp",
  users_uploading_proof: "Kanıt Yükleyen Kullanıcılar",
  user_proofs: "Kullanıcının Kanıtları",
  bulk_action: "Toplu İşlem",
  the_same_treatment_will_be_applied_to_all_proofs:
    "Tüm kanıtlara aynı işlem yapılacaktır.",
  ticket: "Destek",
  tickets: "Destekler",
  create_ticket: "Destek Talebi Oluştur",
  department: "Departman",
  priorities: "Öncelik",
  title: "Başlık",
  my_tickets: "Destek Taleplerim",
  ticket_request: "Destek Talepleri",
  ticket_request1: "Destek Talebi",
  is_description: "Açıklama var mı",
  missions_terminate_swal:
    "Bekleniyor Durumundaki tüm kanıtlar onaylanacaktır. Kalan bakiyeniz iade edilecektir",
  all_reports_control:
    "Bekleniyor durumunda olan tüm raporlar tamamlandı olarak işaretlenecektir.",
  ticket_desc:
    "Yaşadığınız sorunla ilgili olarak bir ekran görüntüsü eklemeniz, sorununuzun anlaşılması açısından oldukça faydalı olacak ve sorunun çözümünü hızlandıracaktır.",
  answer: "Cevapla",
  answer1: "Cevap",
  speeches: "Konuşmalar",
  close_ticket: "Talebi Kapat",
  ticket_close_desc: "Destek talebini kapatmak istediğinize emin misiniz?",
  processing: "İşlemde",
  answered: "Cevaplandı",
  perfect_service: "Perfect Panel Servisi",
  perfect_services: "Perfect Panel Servisleri",
  perfect_service_edit: "Perfect Panel Servis Düzenle",
  perfect_service_detail: "Perfect Panel Servis Detay",
  provider: "Sağlayıcı",
  perfect_panel_status: "Perfect Panel Durumu",
  perfect_service_id: "Perfect Servis ID",
  perfect_service_name: "Perfect Servis Adı",
  perfect_service_type: "Perfect Servis Tipi",
  max: "Max",
  min: "Min",
  perfect_rate: "Rate",
  dripfeed: "DripFeed",
  refill: "Refill",
  synchronization: "Senkronizasyon",
  last_updated_at: "Son Güncellenme Tarihi",
  last_updated_at2: "Son Güncellenme",
  service_package: "Servis Paketi",
  service_packages: "Servis Paketleri",
  service_packages_create: "Servis Paketi Oluştur",
  service_packages_edit: "Servis Paketi Düzenle",
  count: "Miktar",
  total_amount: "Toplam Tutar",
  store: "Mağaza",
  store_settings: "Mağaza Ayarları",
  store_category_id: "Mazağa Kategorisi",
  store_category: "Mazağa Kategorisi",
  store_categories: "Mazağa Kategorileri",
  store_category_create: "Mazağa Kategorisi Oluştur",
  store_category_update: "Mazağa Kategorisi Düzenle",
  store_service: "Mağaza Servisi",
  store_service_id: "Mağaza Servisi",
  store_services: "Mağaza Servisleri",
  store_service_create: "Mağaza Servisi Oluştur",
  store_service_update: "Mağaza Servisi Düzenle",
  store_package: "Mağaza Paketi",
  store_package_id: "Mağaza Paketi",
  store_packages: "Mağaza Paketleri",
  store_package_create: "Mağaza Paketi Oluştur",
  store_package_update: "Mağaza Paketi Düzenle",
  store_package_attribute: "Paket Etiketi",
  store_package_attributes: "Paket Etiketleri",
  store_package_attribute_create: "Paket Etiketi Oluştur",
  store_package_attribute_update: "Paket Etiketi Güncelle",
  store_group: "Mağaza Grubu",
  store_groups: "Mağaza Grupları",
  store_group_create: "Mağaza Grubu Oluştur",
  store_groups_update: "Mağaza Grubu Güncelle",
  store_group_id: "Mağaza Grubu",
  payment_accounts: "Ödeme Hesapları",
  payment_account: "Ödeme Hesabı",
  payment_accounts_me: "Ödeme Hesaplarım",
  payment_accounts_create: "Ödeme Hesabı Oluştur",
  payment_accounts_update: "Ödeme Hesabı Düzenle",
  account_number: "Hesap Numarası",
  full_name: "İsim Soyisim",
  payment_account_type: "Hesap Tipi",
  number: "Numara",
  reward_settings: "Ödül Ayarları",
  reward_categories: "Ödül Kategorileri",
  reward_category: "Ödül Kategorisi",
  reward_category_create: "Ödül Kategorisi Oluştur",
  reward_category_update: "Ödül Kategorisi Düzenle",
  rewards: "Ödüller",
  rewards1: "Ödülleri",
  reward: "Ödül",
  reward_id: "Ödül",
  reward_create: "Ödül Oluştur",
  reward_update: "Ödül Düzenle",
  payment_actions: "Ödeme İşlemleri",
  reward_request: "Ödül Talebi",
  reward_requests: "Ödül Talepleri",
  reward_requests_me: "Ödül Taleplerim",
  reward_request_create: "Ödül Talebi Oluştur",
  approver: "Onaylayan",
  system_approve: "Sistem Onayladı",
  date: "Tarih",
  give_up: "Vazgeç",
  cost: "Maliyet",
  take_reward: "Ödülü Al",
  abandoned: "Vazgeçildi",
  performer: "İşlemi Yapan",
  pending_approval: "Onay Bekleyen",
  store_order: "Mağaza Siparişi",
  store_orders: "Mağaza Siparişleri",
  my_store_orders: "Mağaza Siparişlerim",
  my_store_order: "Mağaza Siparişim",
  store_order_create: "Mağaza Siparişi Oluştur",
  remains_person_count: "Kalan Kişi Sayısı",
  enter_url: "Url giriniz...",
  link: "Link",
  sales: "Satış",
  not_authorized_to_access_this_page: "Bu sayfaya erişmek için yetkiniz yok",
  something_went_wrong: "Hoop! Birşeyler yanlış gitti",
  page_not_found: "Sayfa bulunamadı",
  not_authorized: "Yetkiniz yok",
  please_contact_a_system_administrator:
    "Aradığınız sayfayı bulamadık, lütfen sistem yöneticinizle iletişime geçin veya daha sonra tekrar deneyin.",
  an_error_has_occured:
    "Bir hata oluştu. Sorun devam ederse lütfen bir sistem yöneticisiyle iletişime geçin veya daha sonra tekrar deneyin.",
  this_is_a_dev_only_stacktrace:
    "Bu yalnızca geliştiricilere yönelik bir yığın izlemedir, bunu üretimde göremezsiniz.",
  back_to_home: "Ana Sayfaya Git",
  clear_error: "Hatayı Temizle",
  dashboard: "Dashboard",
  happy_to_see_you_again_your_dashboard:
    "Sizi tekrar sistemde görmekten mutluluk duyuyoruz",
  welcome_back_user: "Tekrar Hoşgeldiniz",
  welcome_back_user1: "Tekrar Hoşgeldin",
  welcome_back_text: "Sizleri tekrar aramızda görmekten mutluluk duyuyoruz.",
  you_do_not_have_authority: "Bu sayfa görüntülemek için yetkiniz yok.",
  balance_transactions: "Bakiye İşlemleri",
  completed: "Tamamlanan",
  id_approved: "Kimlik Onaylı",
  id_not_approved: "Kimlik Onaysız",
  dates_start: "Başlangıç Tarihi",
  dates_end: "Bitiş Tarihi",
  comment: "Yorum",
  inspect: "İncele",
  gig: "Gig",
  subscription: "Abonelik",
  gigs: "Gigler",
  gig_create: "Gig Oluştur",
  subscription_create: "Abonelik Oluştur",
  statistics: "İstatistikleri",
  mega_store: "Mega Mağaza",
  mega_store_orders: "Mega Mağaza Siparişleri",
  subscription_orders: "Abonelik Siparişleri",
  order_tracking: "Sipariş Takibi",
  gig_orders: "Gig Siparişleri",
  gig_order_tracking: "Gig Sipariş Takibi",
  mega_package_name: "Mega Paket Adı",
  orders: "Siparişleri",
  best_selling: "En Çok Satan",
  package_price: "Paket Fiyatı",
  transferred_to_account: "Hesaba Geçecek",
  for_enhanced_account_security: "Gelişmiş hesap güvenliği için",
  create_new_request: "Yeni Talep Oluştur",
  request_list: "Talep Listesi",
  mission_address: "Gig Adresi",
  mission_fee: "Gig Ücreti",
  user_note: "Kullanıcı Notu",
  things_to_be_done: "Yapılması İstenilenler",
  those_waiting: "Bekleyenler",
  added_proof_to_your_mission: "Giginize kanıt ekledi",
  categories: "Kategoriler",
  sss: "S.S.S",
  balance_to_be_loaded: "Yüklenecek bakiye",
  create_order: "Sipariş Oluştur",
  all_gigs: "Tüm Gigler",
  uploaded_proof_gigs: "Kanıt Yüklenen Gigler",
  background_color: "Arka Plan Rengi",
  verified: "Doğrulanmış",
  email_verify: "Email Doğrula",
  phone_verify: "Telefon Doğrula",
  identity_verify: "Kimlik Doğrula",
  send_code: "Kod Gönder",
  send_verification_code: "Doğrulama Kodu Gönder",
  you_did_not_enter_the_code_within_the_requested_time:
    "İstenilen sürede kod girmediniz.",
  resend: "Tekrar Gönder",
  faq: "SSS",
  faqs: "Sıkça Sorulan Sorular",
  faqs_desc: "360 Sosyal hakkında merak ettiğin her şey bu sorularda",
  faqs_create: "Sıkça Sorulan Soru Oluştur",
  faqs_update: "Sıkça Sorulan Soru Güncelle",
  sort: "Sıra",
  number_attachment: "{0} adet ek",
  attachments: "Ekler",
  mission_step_description_1: "Kategori ve servis seçiniz.",
  mission_step_description_2: "Gig açıklamasını giriniz.",
  mission_step_description_3: "Gig detayını giriniz.",
  subscription_step_description_1: "Kategori ve servis seçiniz.",
  subscription_step_description_2: "Abonelik açıklamasını giriniz.",
  subscription_step_description_3: "Abonelik detayını giriniz.",
  gig_create_description:
    "Gerçek kullanıcılarla Gig oluşturun, zirveye ulaşın!",
  order_tracking_description: "Mevcut siparişlerini görmek için tıklayın",
  mega_store_description:
    "Yüksek hacimli siparişleriniz için düşük maliyetli hizmetler sunar. Ağırlıklı olarak sanal hesaplar kullanılır.",
  search_dottt: "Arama...",
  bulk_bonus: "Toplu Bonus",
  mobile_pages: "Mobil Sayfalar",
  mobile_page: "Mobil Sayfa",
  mobile_page_edit: "Mobil Sayfa Düzenle",
  mobile_page_detail: "Mobil Sayfa Detay",
  mobile_page_create: "Mobil Sayfa Oluştur",
  mobile_announcements: "Mobil Duyurular",
  mobile_announcement: "Mobil Duyuru",
  mobile_announcement_edit: "Mobil Duyuru Düzenle",
  mobile_announcement_detail: "Mobil Duyuru Detay",
  mobile_announcement_create: "Mobil Duyuru Oluştur",
  reference: "Referans",
  forgot_my_password: "Şifremi Unuttum",
  forgot_my_password1: "Şifreni mi unuttun?",
  gift_amount: "Hediye Miktarı",
  fill_out_the_form_to_reset_your_password:
    "Şifrenizi sıfırlamak için formu doldurun",
  forgot: "Şifremi Unuttum",
  rejection_templates: "Reddetme Şablonları",
  total_earning: "Toplam Kazanç",
  percent: "Yüzde",
  application_name: "Uygulama Adı",
  kvvk: "kvvk",
  privacy_policy: "Gizlilik Politikası",
  login_text: "Giriş Yap, Gig Vermeye Hemen Başla!",
  login_text1:
    "Sosyal medya da hızlıca yükselmek için doğru yerdesin hemen giriş yap ve gig oluştur",
  login_text2: "Uygun Fiyatlar",
  login_text3:
    "Onlarca hizmet, binlerce gerçek kullanıcıya uygun fiyattan gig tanımla hem sen kazan hem gig yapanlar kazansın!",
  estimated_score: "Tahmini puan",
  is_comment_service: "Yorum Servisi",
  is_subscription_service: "Abonelik Servisi",
  is_api_subscription_service: "Api Abonelik Servisi",
  comments: "Yorumlar",
  comment_you_need_to_make: "Yapmanız gereken yorum",
  gig_quit: "Gigi Bırak",
  gig_report: "Gigi Raporla",
  gig_hide: "Gigi Gizle",
  get_reward: "Ödül Al",
  slug: "Slug",
  is_automatic_except_service: "Otomatik hariç bırak",
  extra_description: "Ekstra Açıklama",
  be_sure_to_read_before_placing_an_order:
    "Sipariş vermeden önce mutlaka okuyunuz",
  ı_approved: "Onaylıyorum",
  field: "Alan",
  open_link: "Linke Git",
  user_url: "Kullanıcı Url",
  before_order_information: "Sipariş öncesi bilgilendirme",
  before_order_information1: "Sipariş öncesi <strong>bilgilendirme</strong>",
  before_order_information_ı_approved:
    "Sipariş öncesi bilgilendirme metnini okudum ve anladım",
  special_comments: "Özel Yorumlar",
  reject_reason: "Reddetme Sebebi",
  papara_balance: "Papara Bakiyesi",
  papara_waiting: "Bekleyen Ödeme",
  papara_number: "Papara Numarası",
  papara_name: "Papara Adı",
  download: "İndir",
  proof_download: "Kanıt İndir",
  copied: "Kopyalandı",
  copy: "Kopyala",
  reference_link: "Referans Linkiniz",
  reference_link1: "Referans Linki",
  reference_link_copy: "Referans Linkini Kopyala",
  kvkk_text:
    "<strong>Kullanıcı Sözleşmesi</strong>’ni ve <strong>KVKK Aydınlatma Metni</strong>’ni okudum, anladım ve kabul ediyorum.",
  user_aggrement:
    "<strong>Açık Rıza Beyanı</strong>’nı okudum, anladım ve bu kapsamda kişisel verilerimin işlenmesi ve aktarılmasını onaylıyorum.",
  whatsapp_support: "Whatsapp Destek",
  support_line: "Destek Hattı",
  app_download: "Uygulamayı İndir",
  contact: "İletişim",
  approval_statuses: "Onay Durumları",
  is_email_verified: "Eposta Doğrulandı",
  is_national_id_verified: "Kimlik Doğrulandı",
  is_phone_verified: "Telefon Doğrulandı",
  start_count: "Başlangıç Sayısı",
  unspecified: "Belirtilmemiş",
  pay_amount: "Ödenecek Tutar",
  next: "Sonraki",
  external_id: "Perfect ID",
  mission_id: "Gig ID",
  auto_exclude: "Otomatik Hariç Bırak",
  mission_auto_exclude: "Gig Otomatik Hariç Bırak",
  mission_auto_exclude_desc:
    "Bu serviste otomatik hariç bırak özelliği aktiftir. Aynı linkle gig eklediğinizde, önceki gigi tamamlayan kullanıcılar yeni gigi yapamaz.",
  mission_order_tracking: "Gig Sipariş Takibi",
  mission_order_tracking_desc:
    "Özelliğin çalışması için linklerin birebir aynı olması gerekir. Önceki linklerinize sipariş takibi sayfasından ulaşabilirsiniz.",
  bulk_approve: "Toplu Onay",
  point_refund: "Puan İadesi",
  point_punish: "Puan Cezası",
  point_punish_desc: "Kullanıcıya vermek istediğiniz puan cezasını girin.",
  point_punish_validator: "Ceza puan 0'dan büyük olmalıdır",
  user_has_rejected_by_service:
    "{0} adlı kullanıcının {1} servisinde {2} reddedilen kanıtı bulunmaktadır!",
  clone: "Klonla",
  subscription_packages: "Abonelik Paketleri",
  hour: "Saat",
  update_external_id: "Perfect ID Güncelle",
  total_gig_count: "Toplam Gig Sayısı",
  subscription_approve_list: "Abonelik Onay Bekleyenler",
  subscription_edit_list: "Abonelik Düzenleme",
  gig_header_placeholder:
    "Siparişinizi hatırlamak için başlık ekleyebilirsiniz (Opsiyonel)",
  perfect_id: "Perfect ID",
  subscription_id: "Abonelik ID",
  subscription_order: "Abonelik Siparişi",
  compulsory_order: "Zorunlu Gig",
  is_compulsory: "Zorunlu",
  organic_interaction_tool: "Organik Etkileşim Aracı",
  organic_interaction_tool_desc:
    "Gerçek kullanıcılar ile sosyal medya hesaplarınıza etkileşim sağlar.",
  otomatic_interaction_tool: "Otomatik Etkileşim Aracı",
  otomatic_interaction_tool_desc:
    "Profilinize siparişinizi bir defa tanımladıktan sonra siparişiniz belirli aralıklarla otomatik oluşur.",
  every_hour: "Saat Arayla",
  subscription_order_confirmation: "Abonelik Sipariş Onayı",
  subscription_order_confirmation_desc:
    "{0} saat arayla {1} kişilik {2} - {3} siparişi siz durdurana kadar otomatik olarak oluşturulacaktır.",
  subscription_person_count_info:
    "Her siparişte kaç kişinin işlem yapacağını seçin.",
  subscription_hour_info:
    "Sipariş oluşturduğunuz saat, başlangıç saati olarak kabul edilir. Seçtiğiniz saat aralığına göre sistem, bu saatten itibaren düzenli olarak sipariş oluşturur.",
  subscription_gender_info: "İşlem yapacak kişilerin cinsiyetini belirleyin.",
  subscription_boost_info:
    "Öne çıkar seçeneği etkinleştirildiğinde, siparişiniz özel alanda listelenir ve daha hızlı tamamlanır.",
  email_or_phone: "E-posta veya Telefon",
  priority: "Öncelik",
  with: "ile",
  how_to_login_yt: "Giriş Yapma ve Şifre Yenileme Nasıl Yapılır?",
  opening_a_new_account_yt: "Yeni Hesap Açma ve Hesap Doğrulama Nasıl Yapılır?",
  what_is_the_store_yt: "Mağaza Nedir ve Nasıl Kullanılır?",
  what_is_the_gig_yt: "Organik Etkileşim Aracı Nedir? Gig Nasıl Oluşturulur?",
  what_is_the_subscription_gig_yt:
    "Otomatik Etkileşim Aracı Nedir? Nasıl Kullanılır?",
  what_is_the_order_tracking_yt: "Sipariş Takibi Nedir ve Nasıl Kullanılır?",
  what_is_the_360social_yt: "360Sosyal Genel Tanıtım ve Kullanım",
  what_is_the_balance_packages_yt: "Bakiye Yükleme Nasıl Yapılır?",
  what_is_the_tickets_yt: "Destek Talebi Nasıl Açılır?",
  all_services: "Tüm Hizmetler",
  add_new_package: "Yeni Paket Ekle",
  popular: "Popüler",
  popular_services: "Popüler Hizmetler",
  reference_system: "Referans Sistemi",
  registration_date: "Kayıt Tarihi",
  last_upload_date: "Son Yükleme Tarihi",
  total_earnings: "Toplam Kazanç",
  what_is_the_reference_system: "Referans Sistemi Nedir?",
  what_is_the_reference_system_description:
    "Arkadaşlarınızı platforma davet edin; onlar bakiye yükledikçe siz de ödül kazanın. </br> Sistem aşağıdaki şekilde işlemektedir:",
  share_your_reference_link: "Refarans Bağlantınızı Paylaşın",
  share_your_reference_link_description:
    "Size özel olarak tanımlanmış referans bağlantınızı arkadaşlarınızla paylaşın.",
  person_you_invite_will_load_the_balance:
    "Davet Ettiğiniz Kişi </br>Bakiye Yüklesin",
  person_you_invite_will_load_the_balance_description:
    "Referans bağlantınız üzerinden kayıt olan her kullanıcı, bakiye yükledikçe tarafınıza kazanç sağlar.",
  total_loading_amount: "Toplam Yükleme Tutarı",
  commission_rate: "Komisyon Oranı",
  cumulative_total_earnings: "Birikimli Toplam Kazanç",
  and_above: "ve üzeri",
  increases_according_to_the_loading_amount: "yükleme tutarına göre artar",
  terms_and_rules: "Şartlar ve Kurallar",
  no_references_yet: "Henüz referansınız bulunmamaktadır",
  no_references_yet_desc:
    "Arkadaşlarınızı davet ederek referans geliri kazanmaya başlayabilirsiniz.",
  what_is_reference_system: "Referans Sistemi Nedir?",
  offer_integrated: "Entegre Offerlar",
  payment_model: "Ödeme Modeli",
  revenue: "Gelir",
  goals: "Hedefler",
  goal: "Hedef",
  goal_id: "Hedef ID",
  offer_id: "Offer ID",
  devices: "Cihazlar",
  countries: "Ülkeler",
  goalID: "Hedef ID",
  isOptional: "Opsiyonel",
  device: "Cihaz",
  offer_services: "Offer Servisleri",
  offer_service: "Offer Servisi",
  offer_service_create: "Offer Servisi Oluştur",
  offer_service_update: "Offer Servisi Güncelle",
  total_point: "Toplam Puan",
  offers: "Offerlar",
  rewards_oyunfor: "Oyunfor Ödülleri",
  get_service: "Servis Getir",
  service_not_found: "Servis Bulunamadı",
  apply: "Uygula",
  video_url: "Video URL",
  short_description: "Kısa Açıklama",
  html: "HTML",
  gig_reports: "Raporlanan Gigler",
  report_count: "Rapor Sayısı",
  controller_user: "Kontrol Eden",
  gig_opener: "Gig Açan",
  gig_approver: "Gig Onaylayan",
  evaluate: "Değerlendir",
  report_users: "Raporlayan Kullanıcılar",
  invoice_information: "Fatura Bilgileri",
  my_invoice_information: "Fatura Bilgilerim",
  tax_number: "Vergi Numarası",
  tax_office: "Vergi Dairesi",
  invoice_name: "Fatura Adı",
  invoice_email: "Fatura E-posta",
  invoice_phone: "Fatura Telefon",
  invoice_address: "Fatura Adresi",
  invoice_tax_number: "Fatura Vergi Numarası",
  invoice_tax_office: "Fatura Vergi Dairesi",
  title_or_name_surname: "Ünvan/Ad Soyad",
  city: "İl",
  district: "İlçe",
  download_invoice: "Fatura İndir",
  create_invoice: "Fatura Kes",
  add_trial_balance: "Deneme Bakiyesi Ekle",
  ai_moderator: "AI Moderatör",
  pending_payment_list: "Bekleyen Ödeme Listesi",
  reward_balance: "Ödül Bakiyesi",
  iban_name: "IBAN Adı",
  bank: "Banka Adı",
  iban: "IBAN",
  total_pending_iban_amount: "Toplam Bekleyen IBAN Tutarı",
  examine_proof: "Kanıt İncele",
  status_en: "Durum (EN)",
  application_name_en: "Uygulama Adı (EN)",
  explanation_en: "Açıklama (EN)",
  mission_steps_en: "Gig Adımları (EN)",
  language: "Dil",
  short_description_en: "Kısa Açıklama (EN)",
  description_en: "Açıklama (EN)",
  telegram_notification: "Telegram Bildirimi",
  remaining_greater_than: "Min Kalan Kişi Sayısı",
  remaining_smaller_than: "Max Kalan Kişi Sayısı",
  person_count_greater_than: "Min Kişi Sayısı",
  person_count_smaller_than: "Max Kişi Sayısı",
  created_at_greater_than: "Oluşturulma Tarihi Başlangıç",
  created_at_smaller_than: "Oluşturulma Tarihi Bitiş",
  confirm_with_detail: "Detayla Onayla",
  enter_detail_code: "Detay Kodu Giriniz",
  reason_for_decline_optional: "Reddetme Sebebi (zorunlu değil)",
  notifications: "Bildirimler",
  new_notification: "Yeni Bildirim",
  add_new_notification: "Yeni bir bildirim oluşturun",
  no_notifications: "Bildirim Yok",
  no_notifications_dec: "Görünüşe göre henüz bir bildirim oluşturmadınız.",
  read: "Okundu",
  unread: "Okunmadı",
  no_data: "Veri bulunamadı",
  no_detail: "Detay eklenmemiş",
  same_ip_entry: "Aynı Ip Girişleri",
  ip_address: "Ip Adresi",
  not_found_same_ip: "Aynı Ip adresinden başka bir giriş bulunamadı.",
  login_date: "Giriş Tarihi",
  sign_in_with_google: "Google ile giriş yap",
  registration_email_verification: "Kayıtda E-posta Doğrulama",
  approved_account_check: "Onaylı Hesap Kontrolü",
  approved_account: "Onaylı Hesap",
  verified_control: "Verified Kontrol",
  check_all: "Tümünü Kontrol Et",
  batch_acceleration: "Toplu Hızlandırma",
  gig_ids: "Gig ID'ler",
  speed_up: "Hızlandır",
  take_it: "Üzerine Al",
  modal_settings: "Modal Ayarları",
  login_papara: "Papara Giriş",
  logs: "Loglar",
  model: "Model",
  day: "Gün",
  papara_active: "Papara Aktif",
  freeze_account: "Hesabı Dondur",
  open_account: "Hesabı Aç",
  batch_stop: "Toplu Sonlandır",
  how_to_use: "Nasıl Kulanılır",
  how_to_uses: "Nasıl Kullanılır Listesi",
  how_to_uses_create: "Nasıl Kullanılır Kaydı Oluştur",
  how_to_uses_update: "Nasıl Kullanılır Kaydı Güncelle",
  daily_wheels: "Günlük Çark",
  mission_auto_approve_rule: "Otomatik Onay Sistemi",
  mission_auto_approve_rules: "Otomatik Onay Sistemi",
  mission_auto_approve_rules_create: "Otomatik Onay Kuralı Oluştur",
  mission_auto_approve_rules_update: "Otomatik Onay Kuralı Güncelle",
  weekdays: "Günler",
  all_day: "Tüm Gün",
  time: "Zaman",
  start_time: "Başlangıç Saati",
  end_time: "Bitiş Saati",
  valid_from: "Geçerlilik Başlangıcı",
  valid_until: "Geçerlilik Bitişi",
  service_ids: "Servis ID'leri",
  user_ids: "Kullanıcı ID'leri",
  usernames: "Kullanıcı Adları",
  scope: "Kapsam",
  all_users: "Tüm Kullanıcılar",
  comma_separated: "Virgül ile ayırın",
  monday: "Pazartesi",
  tuesday: "Salı",
  wednesday: "Çarşamba",
  thursday: "Perşembe",
  friday: "Cuma",
  saturday: "Cumartesi",
  sunday: "Pazar",
  select_all: "Tümünü Seç",
  earning_point: "Kazanılan Puan",

  dataGender: {
    M: "Erkek",
    F: "Kadın",
    N: "Belirsiz",
    ALL: "Hepsi",
  },
  dataApproveType: {
    personal: "Kişisel",
    system: "Sistem",
  },
  storeOrderStatus: {
    completed: "Tamamlandı",
    processing: "İşleniyor",
    "in progress": "Devam Ediyor",
    pending: "Bekleniyor",
    canceled: "İptal Edildi",
    partial: "Sonlandırıldı",
  },
  offerStatus: {
    completed: "Tamamlandı",
    waiting: "Bekleniyor",
    partial_completed: "Kısmen Tamamlandı",
    canceled: "İptal Edildi",
  },
  subscriptionStatus: {
    processing: "Devam Ediyor",
    stopped: "Durduruldu",
    waiting_approve: "Onay Bekleniyor",
    canceled: "İptal Edildi",
    terminated: "Sonlandırıldı",
    completed: "Tamamlandı",
    declined: "Reddedildi",
  },
  orderTrackingTitle: {
    megaStore: "Mega Mağaza Siparişleri",
    gig: "Gig Siparişleri",
    subscription: "Abonelik Siparişleri",
  },

  errors: { something_went_wrong: "Bir şeyler yanlış gitti" },
  validation: {
    general_required: "Gerekli",
    required: "{0} boş olamaz",
    length: "En az {0} karakter olmalıdır",
    email: "Bu alan e-posta olmalıdır",
    password_not_match: "Şifreler Uyuşmuyor",
    step_field_required: "Adım Alanı Zorunlu",
    the_entered_or_selected_value_is_invalid:
      "Girilen veya seçilen değer geçersiz",
    invalid_url: "URL adresi geçersiz",
  },

  menu_home: "Anasayfa",
  menu_order_tracking: "Sipariş Takibi",
  menu_store_order_create: "Mağaza Siparişi Oluştur",
  menu_payment_action: "Ödeme İşlemleri",
  menu_balance_package: "Bakiye Yükle",
  menu_balance_history: "Bakiye Geçmişi",
  menu_payment_action_me: "Ödeme İşlemlerim",
  menu_sss: "S.S.S",
  menu_ticket_requests_me: "Destek Taleplerim",
  menu_price_list: "Fiyat Listesi",
  menu_proofs: "Kanıtlar",
  menu_reward_request: "Ödül Talepleri",
  menu_reward_request_me: "Ödül Taleplerim",
  menu_reward_accounts: "Ödül Hesapları",
  menu_gig_management: "Gig Yönetimi",
  menu_pending_approval: "Onay Bekleyenler",
  menu_gig_edit: "Gig Düzenleme",
  menu_decline_request: "Red Talepleri",
  menu_mission_reports: "Raporlanan Gigler",
  menu_store_orders: "Mağaza Siparişleri",
  menu_proof_inspect: "Kanıt İncele",
  menu_user_in_proofs: "Kullanıcı Bazlı Kanıtlar",
  menu_mission_in_proofs: "Gig Bazlı Kanıtlar",
  menu_mission_user_proofs: "Tüm Kanıtlar",
  menu_social_media_accounts: "Sosyal M. Hesapları",
  menu_social_pending_approval: "Onay Bekleyenler",
  menu_social_banneds: "Yasaklananlar",
  menu_social_verified_control: "Verified Kontrol",
  menu_social_all_accounts: "Tüm Hesaplar",
  menu_users: "Kullanıcılar",
  menu_all_user: "Tüm Kullanıcılar",
  menu_360_user: "360Sosyal Kullanıcıları",
  menu_gigcep_user: "GigCep Kullanıcıları",
  menu_gigcep_send_sms: "GigCep SMS Gönder",
  menu_users_banned: "Yasaklı Kullanıcılar",
  send_sms: "SMS Gönder",
  registration_start_date: "Kayıt Başlangıç Tarihi",
  registration_end_date: "Kayıt Bitiş Tarihi",
  menu_references: "Referanslar",
  menu_services: "Servisler",
  menu_panel_packages: "Panel Paketleri",
  menu_store_settings: "Mağaza Ayarları",
  menu_offer_settings: "Offer Ayarları",
  menu_offer_integrated: "Entegre Offerlar",
  menu_offer_services: "Offer Servisleri",
  menu_packages: "Paketler",
  menu_groups: "Gruplar",
  menu_integrated_services: "Entegre Servisler",
  menu_perfect_service_list: "Perfect Servis Listesi",
  menu_reward_settings: "Ödül Ayarları",
  menu_reward_categories: "Ödül Kategorileri",
  menu_reward_services: "Ödül Servisleri",
  menu_reward_oyunfor: "Oyunfor Ödülleri",
  menu_ticket_management: "Destek Yönetimi",
  menu_payment_management: "Ödeme Yönetimi",
  menu_payment_accounts: "Ödeme Hesapları",
  menu_settings: "Ayarlar",
  menu_service_settings: "Servis Ayarları",
  menu_subscription_packages: "Abonelik Paketleri",
  menu_subscription_management: "Abonelik Yönetimi",
  menu_subscription_approve: "Onay Bekleyenler",
  menu_subscription_edit: "Abonelik Düzenleme",
  menu_information_logs: "Bilgi Logları",
  menu_perfect_service_price_logs: "Perfect Fiyat Değişimleri",
  menu_logs: "Loglar",
  menu_reference_system: "Referans Gelirlerim",
  menu_offers: "Offerlar",
  menu_telegram_notification: "Telegram Bildirimi",
  send_notification: "Bildirim Gönder",
  menu_main_reports: "Raporlar",
  menu_daily_payment_report: "Günlük Ödeme Raporu",
  menu_daily_mission_report: "Günlük Görev Raporu",
  menu_user_spend_report: "Kullanıcı Harcama Raporu",
  menu_user_point_ranks: "Kullanıcı Puan Sıralaması",
  menu_whatsapp: "WhatsApp",
  menu_whatsapp_instances: "WhatsApp Instance",
  menu_whatsapp_messages: "WhatsApp Mesajlar",
  period_daily: "Günlük",
  period_weekly: "Haftalık",
  period_monthly: "Aylık",

  page_title: {
    index: "Dijital ve Sosyal Medyada Organik Çözümler",
    home: "Anasayfa",
  },

  registercustomer: {
    login_with_gig: "Giriş Yap, Gig Vermeye",
    start_now: "Hemen Başla!",
    description:
      "360Sosyal, sosyal medya platformlarında gerçek kullanıcılarla etkileşim sağlayarak içeriklerin daha fazla kişiye ulaşmasını ve organik büyümenin desteklenmesini amaçlayan bir sistemdir.",
  },

  seo: {
    index: {
      title: "Dijital ve Sosyal Medyada Organik Çözümler",
      titleGig: "Gigleri Tamamla, Hediyeler Kazan",
      description:
        "360Sosyal, sosyal medya platformlarında gerçek kullanıcılarla etkileşim sağlayarak içeriklerin daha fazla kişiye ulaşmasını ve organik büyümenin desteklenmesini amaçlayan bir sistemdir.",
      descriptionGig:
        "Gigcep ile boş zamanlarınızı değerlendirin, basit görevleri tamamlayarak hediyeler kazanın.",
      keywords:
        "360sosyal, sosyal medya, organik büyüme, gerçek kullanıcı, etkileşim",
    },
    faq: {
      description:
        "{0} hakkında en sık sorulan soruların yanıtlarını bulun. Hizmetlerimiz, özelliklerimiz ve nasıl başlayacağınız hakkında daha fazla bilgi edinin.",
      keywords: "SSS, sık sorulan sorular, {0}, yardım, destek",
    },
  },
}
